import { makeStyles, Theme, Typography } from '@freighthub/silhouette-core'
import { FC } from 'react'

interface DescriptionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  time?: any
  label: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  text: any
  note?: string
  invertBg?: boolean
}

const useStyles = makeStyles<Theme>((theme) => ({
  description: {
    display: 'flex',
    padding: theme.spacing(0, 4),
    height: 70,
    alignItems: 'center',
  },
  invertBg: {
    '&:nth-child(2n + 1)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  time: {
    width: '150px',
    flex: '0 0 150px',
    textAlign: 'right',
    padding: theme.spacing(0, 3, 0, 0),
    marginRight: theme.spacing(2),
    borderRight: '1px solid',
  },
  information: {
    display: 'flex',
    flex: 1,
  },
  note: {
    flex: 1,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}))

export const Description: FC<DescriptionProps> = ({ invertBg, time, label, note, text }) => {
  const classes = useStyles()
  return (
    <div className={`${classes.description} ${invertBg ? classes.invertBg : ''}`}>
      {time && <div className={classes.time}>{time}</div>}
      <div className={classes.information}>
        <div>
          <Typography variant="subtitle2">{label}</Typography>
          <div>{text}</div>
        </div>
        {note && <div className={classes.note}>{note}</div>}
      </div>
    </div>
  )
}
